<template>
  <div v-if="!isMobile()">
    <div class="bridgeBox">
      <div class="bridgeWrap">
        <!-- 상단 탭 메뉴 -->
        <div class="tabWrap">
          <ul>
            <!-- 25년 업데이트 -->
            <li v-bind:class="{ active: currentTab == 0 }" @click="onClickTab(0)">
              <h3>DRAGO</h3>
              <span>ETH</span><span>Arena-Z</span>
            </li>
            <li v-bind:class="{ active: currentTab == 1 }" @click="onClickTab(1)">
              <h3>DRAGO</h3>
              <span>Polygon</span><span>Arena-Z</span>
            </li>
            <li v-bind:class="{ active: currentTab == 2 }" @click="onClickTab(2)">
              <h3>DST</h3>
              <span>Polygon</span><span>Arena-Z</span>
            </li>
            <!-- <li v-bind:class="{ active: currentTab == 3 }" @click="onClickTab(3)">
              <h3>DST</h3>
              <span>Arena-Z</span><span>Polygon</span>
            </li> -->
            <li v-bind:class="{ active: currentTab == 4 }" @click="onClickTab(4)">
              <h3>LOKA</h3>
              <span>Polygon</span><span>ETH</span>
            </li>
            <li class="tabPoint" onclick="window.open('https://bridge.arena-z.gg/bridge/arena-z', '_blank')">
              <h3>LOKA</h3>
              <span class="bridge-icon-point">ETH </span><span>Arena-Z</span>
              <span class="Bridge-Point"></span><i></i>
            </li>
          </ul>
        </div>

        <!-- 콘텐츠 -->
        <div class="contents">



          <!-- 2025 업데이트 -->
          <!-- DRAGO ETH > AZ -->
          <div class="list active">
            <div class="BridgeBtnWrap" v-if="!isNetwork(currentTabData.network.id)">
              <div class="warningInfo">
                <img src="/img/renewal/icon_info.png" alt="경고 메시지" />
                <span>Wrong network. Click the button to change to {{ currentTabData.network.name }} Mainnet</span>
              </div>
              <div class="ChangeWrap">
                <button :class="{
                  'PolygonWrap': currentTabData.network.code === 'polygon',
                  'EthWrap': currentTabData.network.code === 'eth',
                  'ArenazWrap': currentTabData.network.code === 'arenaz'
                }" @click="onClickChangeNetwork(currentTabData.network.id)">
                  <span><img :src="`/img/bridge/icon_${currentTabData.network.code}.png`" /></span>
                  <p>{{ currentTabData.network.code.toUpperCase() }}</p>
                </button>
              </div>
            </div>

            <div v-if="currentTabData.token == 'DRAGO'" class="boxWrap">
              <div v-if="myDragos.length > 0" id="selectBox">
                <ul>
                  <li v-for="(drago, dragoIndex) in pageDragos" v-bind:key="dragoIndex" :class="drago === null ? 'nodrago' : ''">
                    <div v-if="drago != null" class="thumnail">
                      <div style="width: 220px; height: 220px; cursor: pointer" @click="onClickDrago(drago)">
                        <img v-bind:src="getDragoAsset(drago.tokenId)" width="220px" height="220px" />
                      </div>
                    </div>
                    <div v-if="drago != null" class="infoBox">
                      <h4>
                        <span class="tit">DRAGO</span><span>#{{ drago.tokenId }}</span>
                      </h4>
                    </div>
                    <div v-if="drago != null" class="inputBox">
                      <input type="checkbox" v-bind:name="`chk${drago.tokenId}`" v-bind:id="`chk${drago.tokenId}`"
                        v-bind:value="`${drago.tokenId}`" class="inputs" v-model="selectedDrago" />
                      <label v-bind:for="`chk${drago.tokenId}`"><span>Select</span></label>
                    </div>
                  </li>
                </ul>
              </div>
              <div v-else id="selectBox" style="height: 300px;">
                <p style="text-align: center; color: #fff; margin-top: 70px; font-size: 22px;">There is no drago on the
                  {{ currentTabData.network.name }} network</p>
                <img src="/img/genesis/select-area-drago.png" style="margin-left: calc(50% - 64px); margin-top: 80px" />
              </div>
              <div class="pagination">
                <button id="prevBtn" @click="onClickDragoPage(currentPage - 1)"></button>
                <input type="text" v-bind:value="currentPage" />
                <span>Of</span>
                <span>{{ numPage }}</span>
                <button id="nextBtn" @click="onClickDragoPage(currentPage + 1)"></button>
              </div>
              <div class="btnWrap">
                <button @click="onClickDragoBridge()">BRIDGE</button>
              </div>
            </div>
            <div v-else class="boxWrap">
              <ul class="boxWrap2">
                <li class="leftBox">
                  <div class="iconWrap">
                    <img :src="`/img/bridge/icon_${currentTabData.token.toLowerCase()}.png`" alt="loka icon" />
                  </div>
                  <h4 class="title">{{ currentTabData.token.toUpperCase() }}</h4>
                  <p class="desc">{{ currentTabData.network.name }} Mainnet</p>
                  <h5 class="numWrap">{{ bridge.balance | eth }}</h5>
                </li>
                <li class="rightBox">
                  <div class="stepBox">
                    <div :class="`${currentTabData.network.name.toLowerCase()}Step`">
                      <div class="imgWrap">
                        <img :src="`/img/bridge/icon_${currentTabData.network.code}.png`"
                          :alt="`${currentTabData.network.name} icon`" />
                      </div>
                      <p class="step1Title">{{ currentTabData.network.display }}</p>
                    </div>
                    <div :class="`${currentTabData.target.name.toLowerCase()}Step`">
                      <div class="imgWrap">
                        <img :src="`/img/bridge/icon_${currentTabData.target.code}.png`"
                          :alt="`${currentTabData.target.display} icon`" />
                      </div>
                      <p class="step2Title">{{ currentTabData.target.display }}</p>
                    </div>
                  </div>
                  <div class="forms">
                    <div class="formWrap">
                      <input type="text" v-model="bridge.amount" /><label>{{ currentTabData.token.toUpperCase()
                      }}</label>
                    </div>
                    <button class="btnPoint" @click="currentTab === 4 ? onWithdrawLoka() : onClickTokenBridge()">BRIDGE</button>
                  </div>
                </li>
              </ul>
            </div>
            <div class="history">
              <div class="title">
                <img src="/img/bridge/icon_history.webp" alt="history icon" />
                <h4>History</h4>
              </div>
              <div class="listWrap">
                <div class="listItem">
                  <table>
                    <colgroup>
                      <col style="width: 180px" />
                      <col style="width: auto" />
                      <col style="width: 260px" />
                    </colgroup>
                    <thead>
                      <th style="padding-left: 70px;">Time</th>
                      <th style="padding-left: 90px;">Send Tx</th>
                      <th style="padding-left: 90px;">Confirm Tx</th>
                      <th style="padding-left: 90px;">Amount</th>
                      <th style="padding-left: 80px;">Status</th>
                    </thead>
                    <tbody>
                      <tr v-for="(log2, logIdx2) in bridge.history"
                        v-bind:key="logIdx2">
                        <td>{{log2.logDate | date}}</td>
                        <td @click="onClickAddress(log2.txHash, 1);" style="cursor: pointer;">{{log2.txHash | address}}</td>
                        <td @click="onClickAddress(log2.claimTxHash, 0);" style="cursor: pointer;">{{log2.claimTxHash | address}}</td>
                        <td>{{log2.amount | amount}} WLOKA</td>
                        <td v-if="log2.status == 0" class="claim" @click="onClaim(log2)"><p>claim</p></td>
                        <td v-if="log2.status == 99" class="completed"><p>Completed</p></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="pagination">
                  <button id="prevBtn" @click="onClickHistoryPage(bridge.currentPage - 1)"></button>
                  <input type="text" v-bind:value="bridge.currentPage" />
                  <span>Of</span>
                  <span>{{bridge.numPage}}</span>
                  <button id="nextBtn" @click="onClickHistoryPage(bridge.currentPage + 1)"></button>
                </div>
              </div>
            </div>
          </div>



          <!-- 팝업 -->
          <div class="popup">
            <div class="popupWrap">
              <div class="popupTitle">
                <h5>BRIDGE</h5>
                <i class="popupCloseIco"></i>
              </div>
              <div class="popupText">
                <p>
                  Move <strong>0000 LOKA</strong> from Polygon Mainnet to
                  Ethereum Mainnet. <br />
                  Pick it up when the process is complete.
                </p>
                <button class="popupClose">OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #00000099;
        cursor: pointer;
        z-index: 900;
      " v-if="
        modals.bridge == true ||
        modals.withdraw == true ||
        modals.deposit == true ||
        modals.claim == true
      " @click="closeAllPopup()"></div>
    <div v-if="modals.bridge" style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      ">
      <div class="popup-head-text2" style="position: absolute; left: 0px; top: 20px; width: 100%">
        {{currentTabData.token}} {{currentTabData.network.display}} -> {{currentTabData.target.display}} Bridge processing
      </div>
      <div class="popup-content-text" style="
          position: absolute;
          left: 5%;
          top: 110px;
          width: 90%;
          height: 200px;
        ">
        Wait for bridge...<br /><br />
        It may take up a few minutes depending on the Polygon network situation<br /><br />
        Your transaction hash is <br /><a v-bind:href="`${currentTabData.network.explorer}/tx/${tx_id}`" target="_blank"
          style="color: #000; text-decoration: underline">{{ tx_id.substring(0, 30) }}<br />{{ tx_id.substring(30)
          }}</a>
      </div>
      <div id="loading-image" style="position: absolute; left: calc(50% - 40px); bottom: 140px"></div>
      <div style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        ">
        <div @click="closeAllPopup()" class="popup-btn2"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer">
          OK
        </div>
      </div>
    </div>
    <div v-if="modals.deposit" style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      ">
      <div class="popup-head-text2" style="position: absolute; left: 0px; top: 20px; width: 100%">
        LOKA ETH -> POLYGON Bridge processing
      </div>
      <div class="popup-content-text" style="
          position: absolute;
          left: 5%;
          top: 110px;
          width: 90%;
          height: 200px;
        ">
        Wait for bridge...<br /><br />
        It may take up to 20-30 minutes depending on the Ethereum network
        situation.<br /><br />
        Your transaction hash is <br /><a v-bind:href="`${currentTabData.network.explorer}/tx/${tx_id}`" target="_blank"
          style="color: #000; text-decoration: underline">{{ tx_id.substring(0, 30) }}<br />{{ tx_id.substring(30)
          }}</a>
      </div>
      <div id="loading-image" style="position: absolute; left: calc(50% - 40px); bottom: 140px"></div>
      <div style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        ">
        <div @click="closeAllPopup()" class="popup-btn2"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer">
          OK
        </div>
      </div>
    </div>
    <div v-if="modals.claim" style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      ">
      <div class="popup-head-text2" style="position: absolute; left: 0px; top: 20px; width: 100%">
        LOKA POLYGON -> ETH claim processing
      </div>
      <div class="popup-content-text" style="
          position: absolute;
          left: 5%;
          top: 110px;
          width: 90%;
          height: 200px;
        ">
        Wait for claim...<br /><br />
        It may take up to 20-30 minutes depending on the Ethereum network
        situation.<br /><br />
        Your transaction hash is <br /><a v-bind:href="`https://etherscan.io/tx/${tx_id}`" target="_blank"
          style="color: #000; text-decoration: underline">{{ tx_id.substring(0, 30) }}<br />{{ tx_id.substring(30)
          }}</a>
      </div>
      <div id="loading-image" style="position: absolute; left: calc(50% - 40px); bottom: 140px"></div>
      <div style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        ">
        <div @click="closeAllPopup()" class="popup-btn2"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer">
          OK
        </div>
      </div>
    </div>
    <div v-if="modals.withdraw" style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      ">
      <div class="popup-head-text2" style="position: absolute; left: 0px; top: 20px; width: 100%">
        LOKA POLYGON -> ETH Bridge processing
      </div>
      <div class="popup-content-text" style="
          position: absolute;
          left: 5%;
          top: 110px;
          width: 90%;
          height: 200px;
        ">
        Wait for bridge...<br /><br />
        It may take up to 30minutes ~ 6hours depending on the Polygon network
        situation.<br />
        After transaction completed, you should claim the loka in history<br />
        <br />
        Your transaction hash is <br /><a v-bind:href="`https://polygonscan.com/tx/${tx_id}`" target="_blank"
          style="color: #000; text-decoration: underline">{{ tx_id.substring(0, 30) }}<br />{{ tx_id.substring(30)
          }}</a>
      </div>
      <div id="loading-image" style="position: absolute; left: calc(50% - 40px); bottom: 140px"></div>
      <div style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        ">
        <div @click="closeAllPopup()" class="popup-btn2"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer">
          OK
        </div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>
<script>
import { Parallax } from "@/components";
import config from "../config.js";
import moment from "moment";
import axios from "axios";
import { connectWallet, send, packUint256, packUint256Array, checkLoka, depositDrago, depositLoka, withdrawLoka, withdrawReceive, changeNetwork, ETH, getNetwork } from "../utils/wallet";
import VueRouter from 'vue-router'

let ETH_NETWORK = {
  id: process.env.VUE_APP_NETWORK_ID_ETH,
  name: "Ethereum",
  code: "eth",
  display: "Ethereum",
  index: 0,
  explorer: "https://etherscan.io"
}
let POLYGON_NETWORK = {
  id: process.env.VUE_APP_NETWORK_ID_POL,
  name: "Polygon",
  code: "polygon",
  display: "Polygon",
  index: 1,
  explorer: "https://polygonscan.com"
}
let ARENAZ_NETWORK = {
  id: process.env.VUE_APP_NETWORK_ID_AZ,
  name: "Arenaz",
  display: "Arena-Z",
  code: "arenaz",
  index: 2,
  explorer: "https://explorer.arenaz.io"
}
let TABS = [
  {
    token: "DRAGO",
    network: ETH_NETWORK,
    target: ARENAZ_NETWORK,
    bridge: process.env.VUE_APP_DRAGO_BRIDGE_ADDR_ETH
  }, {
    token: "DRAGO",
    network: POLYGON_NETWORK,
    target: ARENAZ_NETWORK,
    bridge: process.env.VUE_APP_DRAGO_BRIDGE_ADDR_POL
  }, {
    token: "DST",
    network: POLYGON_NETWORK,
    target: ARENAZ_NETWORK,
    contract: process.env.VUE_APP_DST_ADDR_POL,
    bridge: process.env.VUE_APP_DST_BRIDGE_ADDR_POL
  }, {
    token: "DST",
    network: ARENAZ_NETWORK,
    target: POLYGON_NETWORK,
    contract: process.env.VUE_APP_DST_ADDR_AZ,
    bridge:process.env.VUE_APP_DST_BRIDGE_ADDR_AZ
  }, {
    token: "LOKA",
    network: POLYGON_NETWORK,
    target: ETH_NETWORK,
    contract: process.env.VUE_APP_LOKA_ADDR_POL
  }
]
const router = new VueRouter({
  routes: [
    { path: '/', redirect: '/' }
  ]
})


export default {
  name: "Bridge",
  bodyClass: "bridge-page",
  components: {
    Parallax
  },
  created() { },

  mounted: async function () {
    await connectWallet(this.$store);
    await this.onClickTab(0);
  },
  beforeDestroy() { },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    isNetwork(id) {
      return this.networkId == id;
    },
    closeAllPopup() {
      this.closeModal('deposit');
      this.closeModal('bridge');
      this.closeModal('withdraw');
      this.closeModal('claim');
    },
    closeModal(modal) {
      this.modals[modal] = false;
    },
    openModal(modal) {
      this.closeAllPopup();

      this.modals[modal] = true;
    },
    onClickDragoPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page >= this.numPage) {
        page = this.numPage;
      }
      this.currentPage = page;
      this.calcPageDrago();
    },
    async onClickHistoryPage(page) {
      if (page < 1) {
        page = 1;
      }
      if (page >= this.bridge.numPage) {
        page = this.bridge.numPage;
      }
      this.bridge.currentPage = page;
      switch (this.currentTab) {
        case 1:
          await this.getHistory(0, page);
          break;
        case 2:
          await this.getHistory(1, page);
          break;
      }
    },
    async onClickChangeNetwork(id) {
      this.networkId = await changeNetwork(id)
    },
    async onClickDrago(drago) {

    },
    async onClickTab(tab) {
      this.currentTab = tab;
      this.currentTabData = TABS[tab];
      this.networkId = await getNetwork();
      this.bridge.amount = 0;
      this.bridge.balance = 0;

      if (tab >= 2 && tab <= 4) {
        if (!this.isNetwork(this.currentTabData.network.id)) {
          this.networkId = await changeNetwork(this.currentTabData.network.id);
        }
      }
      await this.load();
    },
    async ethCall(contract, data) {
      try {
        console.log({
          method: 'eth_call',
          params: [{
            to: contract,
            data: data
          }, 'latest']
        });
        return await window.ethereum.request({
          method: 'eth_call',
          params: [{
            to: contract,
            data: data
          }, 'latest']
        });
      } catch (err) {
        console.error('Error getting token balance:', err);
      }
      return null;
    },
    async getBalance() {
      const walletAddress = this.getAddress();
      const balanceOf = `0x70a08231`;
      const data = `${balanceOf}000000000000000000000000${walletAddress.substring(2)}`;
      const balance = await this.ethCall(this.currentTabData.contract, data);
      return balance;
    },
    async load() {
      console.log("TAB", this.currentTab);
      switch (this.currentTab) {
        case 0:
          await this.getDragoInventory();
          await this.getBridgeHistory();
          break;
        case 1:
          await this.getDragoInventory();
          await this.getBridgeHistory();
          break;
        case 2:
          this.bridge.amount = 0;
          this.bridge.balance = await this.getBalance();
          await this.getBridgeHistory();
          break;
        case 3:
          // await this.getHistory(1, this.bridge.currentPage);
          this.bridge.amount = 0;
          this.bridge.balance = await this.getBalance();
          break;
        case 4:
          await this.getHistory(1, this.bridge.currentPage);
          this.bridge.amount = 0;
          this.bridge.balance = await this.getBalance();
          break;
      }
    },
    async onClaim(log) {
      this.networkId = await getNetwork();
      if (!this.isNetwork(config.network.eth)) {
        // this.$store.commit(
        // "alert",
        // "Wrong network. You should change network to Ehtereum mainnet for claim loka."
        // );
        this.networkId = await changeNetwork(config.network.eth)
        if (!this.isNetwork(config.network.eth))
          return;
      }
      console.log(log);
      var ret = await axios.post(`${config.api.nft_url}/bridge/loka/withdraw`, {
        txHash: log.txHash
      });
      let self = this;
      if (ret.data.result == true) {
        withdrawReceive(this.$store, ret.data.sig)
          .on("transactionHash", async (txHash) => {
            console.log("transactionHash");
            console.log(txHash);
            self.tx_id = txHash;
            self.openModal("claim");
          })
          .on("receipt", async (receipt) => {
            console.log("receipt");
            console.log(receipt);
            // resolve({result: true, data: receipt});
          })
          .on("error", (error) => {
            console.log("error");
            console.log(error);
            self.$store.commit(
              "alert",
              "Transaction canceled by user."
            );
          });
      } else {
        self.$store.commit(
          "alert",
          "Polygon checkpoints haven't arrived yet. It will be processed at the next checkpoint. It can take anywhere from 30 minutes to up to 6 hours."
        );
      }
      console.log(ret.data);
    },
    onClickAddress(tx, network) {
      if (tx == null || tx == "") {
        return;
      }
      switch (network) {
        case 0:
          window.open(`${config.etherscan.url}/tx/${tx}`, "_blank");
          break;
        case 1:
          window.open(`${config.polygonscan.url}/tx/${tx}`, "_blank");
          break;
        case 1:
          window.open(`${config.polygonscan.url}/tx/${tx}`, "_blank");
          break;
      }
    },
    async onClickDragoBridge() {
      this.networkId = await getNetwork();
      if (!this.isNetwork(this.currentTabData.network.id)) {
        this.networkId = await changeNetwork(this.currentTabData.network.id)
        if (!this.isNetwork(this.currentTabData.network.id)) {
          this.$store.commit(
            "alert",
            `Wrong network. You should change network to ${this.currentTabData.network.display} mainnet.`
          );
          return;
        }
      }
      if (this.selectedDrago.length == 0) {
        this.$store.commit(
          "alert",
          "Select dragos to bridge."
        );
        return;
      }
      console.log(this.selectedDrago);
      let self = this;
      let DEPOSITS = "0x9409745b";
      let START = "0000000000000000000000000000000000000000000000000000000000000020"
      let data = `${DEPOSITS}${START}${packUint256Array(this.selectedDrago)}`;
      console.log(this.currentTabData);
      send(this.$store.state.account.wallet.address, this.currentTabData.bridge, data)
        .on("transactionHash", async (txHash) => {
          console.log("transactionHash");
          console.log(txHash);
          self.tx_id = txHash;
          self.openModal("bridge");
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          console.log(receipt);
          // resolve({result: true, data: receipt});
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
          self.$store.commit(
            "alert",
            "Transaction canceled by user."
          );
        });
    },
    async onClickTokenBridge() {
      this.networkId = await getNetwork();
      if (!this.isNetwork(this.currentTabData.network.id)) {
        this.networkId = await changeNetwork(this.currentTabData.network.id)
        if (!this.isNetwork(this.currentTabData.network.id)) {
          this.$store.commit(
            "alert",
            `Wrong network. You should change network to ${this.currentTabData.network.display} mainnet.`
          );
          return;
        }
      }
      let self = this;
      const ETH_UNIT = 1000000000000000000;
      const DEPOSIT = "0xb6b55f25";
      let data = `${DEPOSIT}${packUint256(this.bridge.amount*ETH_UNIT)}`;
      console.log(this.currentTabData);
      send(this.$store.state.account.wallet.address, this.currentTabData.bridge, data)
        .on("transactionHash", async (txHash) => {
          console.log("transactionHash");
          console.log(txHash);
          self.tx_id = txHash;
          self.openModal("bridge");
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          console.log(receipt);
          // resolve({result: true, data: receipt});
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
          self.$store.commit(
            "alert",
            "Transaction canceled by user."
          );
        });
    },
    async onDepositLoka() {
      this.networkId = await getNetwork();
      if (!this.isNetwork(config.network.eth)) {
        // this.$store.commit(
        // "alert",
        // "Wrong network. You should change network to Ehtereum mainnet."
        // );
        this.networkId = await changeNetwork(config.network.eth)
        if (!this.isNetwork(config.network.eth))
          return;
      }
      if (this.loka == 0) {
        this.$store.commit(
          "alert",
          "Input loka amount."
        );
        return;
      }
      let self = this;
      await checkLoka(this.$store, 0, this.loka);
      depositLoka(this.$store, this.loka)
        .on("transactionHash", async (txHash) => {
          console.log("transactionHash");
          console.log(txHash);
          self.tx_id = txHash;
          self.openModal("deposit");
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          console.log(receipt);
          // resolve({result: true, data: receipt});
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
          self.$store.commit(
            "alert",
            "Transaction canceled by user."
          );
        });
    },
    async onWithdrawLoka() {
      this.networkId = await getNetwork();
      if (!this.isNetwork(config.network.polygon)) {
        // this.$store.commit(
        // "alert",
        // "Wrong network. You should change network to Polygon mainnet."
        // );
        this.networkId = await changeNetwork(config.network.polygon)
        if (!this.isNetwork(config.network.polygon))
          return;
      }
      if (this.bridge.amount == 0) {
        this.$store.commit(
          "alert",
          "Input wloka amount."
        );
        return;
      }
      let self = this;
      withdrawLoka(this.$store, this.bridge.amount)
        .on("transactionHash", async (txHash) => {
          console.log("transactionHash");
          console.log(txHash);
          self.tx_id = txHash;
          self.openModal("withdraw");
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          console.log(receipt);
          // resolve({result: true, data: receipt});
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
          self.$store.commit(
            "alert",
            "Transaction canceled by user."
          );
        });
    },
    clearDragoSelect() {
      this.selectedDrago = [];
    },
    getDragoAsset(tokenId) {
      return `${config.api.drago_url}/${tokenId}`;
    },
    calcPageDrago() {
      let tmp = [];
      for (
        let i = (this.currentPage - 1) * 10;
        i < this.currentPage * 10;
        ++i
      ) {
        if (i >= this.myDragos.length) {
          break;
        }
        tmp.push(this.myDragos[i]);
      }
      for (let i = tmp.length; i < 10; ++i) {
        tmp.push(null);
      }
      this.pageDragos = tmp;
      this.selectedDrago = [];
    },
    getAddress() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }
      return address;
    },
    async getDragoInventory() {
      var ret = await axios.post(`${config.api.nft_url}/drago/inventory`, {
        address: this.getAddress(),
        network: this.currentTabData.network.index
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.myDragos = ret.data.myDragos;
        this.numPage = Math.floor((this.myDragos.length - 1) / 10) + 1;
        this.currentPage = 1;
        this.calcPageDrago();
        this.selectedDrago = [];
      }
    },
    async getBridgeHistory() {
      this.bridge.history = [];
      return;
      let type = this.currentTabData.network.code;
      let token = this.currentTabData.token.toLowerCase();
      let ret = await axios.post(`${config.api.nft_url}/bridge/${token}/history`, {
        publicKey: this.getAddress(),
        network: this.currentTabData.network.index
      });
      if (ret.data.result) {
        this.bridge.history = ret.data.history;
      }
    },
    async getHistory(network, page = 1) {
      let address = this.getAddress();

      var ret = await axios.post(`${config.api.nft_url}/bridge/history`, {
        publicKey: address,
        page: page,
        network: network
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.bridge.loka = ret.data.loka;
        this.bridge.wloka = ret.data.wloka;
        this.bridge.history = ret.data.history;
        this.bridge.numPage = Math.floor((ret.data.num - 1) / 8) + 1;
        this.bridge.currentPage = ret.data.page;
      }
    },
  },
  watch: {
    "$store.state.account.wallet": async function (val) {
      await this.load();
    },
  },
  filters: {
    comma(val) {
      return Number(val).toLocaleString("en-US");
      //return String(val).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    date(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm");
      }
    },
    address(val) {
      if (val == null) {
        return "";
      }
      return val.substring(0, 5) + "..." + val.substring(val.length - 3);
    },
    eth(val) {
      if (val == null) {
        return 0;
      }
      return Math.floor(parseInt(val, 16) / 10 ** 14) / 10000;
    },
    amount(val) {
      if (val == null) {
        return 0;
      }
      return Number(ETH(val).toFixed(4)).toLocaleString("en-US");
    }
  },
  data: function () {
    return {
      tx_id: "",
      myDragos: [],
      pageDragos: [],
      modals: {
        bridge: false,
        deposit: false,
        withdraw: false,
        claim: false
      },
      networkId: 0,
      numPage: 1,
      currentPage: 1,
      wloka: 0,
      loka: 0,


      selectedDrago: [],
      currentTab: 0,
      currentTabData: TABS[0],
      bridge: {
        history: [],
        numPage: 1,
        currentPage: 1,
        loka: 0,
        wloka: 0,
        balance: 0,//브리지할 토큰 잔액
        amount: 0,//브릿지할 토큰 양
      }

    };
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@100;300;400;500;600;700;800;900&display=swap");

* {
  margin: 0;
  padding: 0;
  font-family: "Poppins", sans-serif;
}

li {
  list-style: none;
}

.bridgeBox {
  position: relative;
  padding: 120px 0 150px;
  background: #04050d;
}

.bridgeBox::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 400px;
  background: #0f1326;
  z-index: -1;
}

.bridgeWrap {
  width: 1180px;
  margin: 0 auto;
  background: #04050d;
}

/* 탭 */
.tabWrap {
  padding: 40px 0 26px;
}

.tabWrap ul {
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
}

.tabWrap ul li {
  /*width: 200px;*/
  width: 100%;
  height: 110px;
  padding: 28px 0;
  border-radius: 10px;
  background: #190652;
  text-align: center;
  box-sizing: border-box;
  transition: all ease 0.3s;
  cursor: pointer;
}

.tabWrap li.tabPoint {
  /*width: 130px;*/
}

.tabWrap ul li h3 {
  color: #4d2dbb;
  font-size: 24px;
  font-weight: 600;
}

.tabWrap ul li span {
  position: relative;
  padding: 0 10px 0;
  color: #4d2dbb;
  font-size: 13px;
  font-weight: 400;
}
.tabWrap ul li span.bridge-icon-point::before {
  display: inline-block;
  position: absolute;
  top: 6px;
  right: 4px;
  transform: rotate(-135deg);
  width: 6px;
  height: 6px;
  border-top: 1px solid #4d2dbb;
  border-right: 1px solid #4d2dbb;
  content: "";
}

.tabWrap ul li span.bridge-icon-point {
  padding: 0 14px 0 0;
}

.tabWrap ul li span.bridge-icon-point::after {
  right: -2px;
}


.tabWrap ul li span::after {
  display: inline-block;
  position: absolute;
  top: 6px;
  right: 0;
  transform: rotate(45deg);
  width: 6px;
  height: 6px;
  border-top: 1px solid #4d2dbb;
  border-right: 1px solid #4d2dbb;
  content: "";
}

.tabWrap ul li span:last-child::after {
  display: none;
}

.tabWrap ul li span.Bridge-Point::after {
  display: none;
}

.tabWrap ul li span.Bridge-Point {
  padding: 0 0 0 0;
}

.tabWrap ul .tabPoint span:nth-child(3)::after {
  display: none;
}

.tabWrap ul li i {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-image: url('/img/renewal/icon_newtap.png');
  transform: translateY(2px);
}

.tabWrap ul li:hover i {
  background-image: url('/img/renewal/icon_newtap_on.png');
}

.tabWrap ul li:hover {
  border-radius: 4px;
  background: linear-gradient(to top, #4d1bf1, #2b4ae7);
  transition: all ease 0.3s;
}

.tabWrap ul li:hover h3 {
  color: #3fe6ff;
}

.tabWrap ul li:hover span {
  color: #fff;
}

.tabWrap ul li:hover span::after,
.tabWrap ul li:hover span::before {
  border-color: #fff;
}

.tabWrap ul li.active {
  border-radius: 10px;
  background: #361ad8;
}

.tabWrap ul li.active h3 {
  color: #3fe6ff;
  font-size: 24px;
  font-weight: 600;
}

.tabWrap ul li.active span {
  color: #fff;
  font-size: 13px;
  font-weight: 400;
}

.tabWrap ul li.active span::after {
  border-color: #fff;
}

/* tab menu */
.contents {
  position: relative;
}

.contents>div {
  display: none;
}

.contents>div.active {
  display: block;
}

/* 체크 */
#selectBox {
  margin: 0 auto;
}

#selectBox ul {
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  margin: 0;
  padding: 0;
}

#selectBox li {
  position: relative;
  display: flex;
  /* flex: 0 1 220px; */
  width: calc(20% - 8px);
  flex-direction: column;
  height: 270px;
  margin: 0 0 10px;
  list-style: none;
  border-radius: 8px;
  background: #ededed;
}

#selectBox li .inputBox {
  position: absolute;
  top: 50%;
  left: 50%;
  opacity: 1;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  transition: 0.3s;
}

#selectBox li .inputBox label {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

#selectBox li:hover .inputBox {
  opacity: 1;
}

#selectBox li .inputBox.active {
  opacity: 1;
}

#selectBox li .thumnail {
  overflow: hidden;
}

#selectBox li img {
  width: 100%;
  transition: ease 0.3s;
}

#selectBox li:hover img {
  transform: scale(1.1);
}

/* info */
#selectBox li .infoBox {
  padding-top: 10px;
  height: 30px;
  line-height: 50px;
}

#selectBox li .infoBox h4 {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}

#selectBox li .infoBox h4 span {
  color: #000;
  font-size: 12px;
  font-weight: 500;
}

#selectBox li .infoBox h4 .tit {
  width: 94px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

#selectBox .inputBox input {
  display: none;
}

#selectBox .inputBox input+label {
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 120px;
  height: 40px;
  padding: 0 0 0 6px;
  border-radius: 20px;
  background: hsla(226, 21%, 16%, 0.7);
}

#selectBox .inputBox input+label>span {
  padding: 0 0 0 10px;
  vertical-align: middle;
}

#selectBox .inputBox input+label::before {
  content: "";
  display: inline-block;
  width: 28px;
  height: 28px;
  margin: 0 6px 0 0;
  border-radius: 50%;
  background-color: #fff;
  background-image: url("/img/bridge/icon_arr_off.svg");
  background-repeat: no-repeat;
  background-position: 50%;
  vertical-align: middle;
}

#selectBox .inputBox input:checked+label::before {
  content: "";
  display: inline-block;
  width: 28px;
  height: 28px;
  background-color: #fff;
  background-image: url("/img/bridge/icon_arr_on.svg");
  background-repeat: no-repeat;
  background-position: 50%;
  vertical-align: middle;
}

#selectBox .inputBox input:checked+label {
  background: #0d6eff;
}

/* 2,3 번째 탭 */
.warningInfo {
  display: flex;
  justify-content: center;
  align-items: center;
  /* transform: translateY(-30px); */
  margin: 0 30px 0 0;
}

.warningInfo span {
  margin: 0 0 0 10px;
  color: #f85e49;
  font-size: 16px;
  font-weight: 400;
}

.boxWrap {
  margin: 0 0 40px;
  padding: 20px;
  border-radius: 20px;
  background: #2a304c;
  box-sizing: border-box;
}

.boxWrap .boxWrap2 {
  display: flex;
  flex-flow: row wrap;
  border-radius: 20px;
  overflow: hidden;
}

.boxWrap .boxWrap2 li {
  flex: 0 1 50%;
  text-align: center;
}

.boxWrap .boxWrap2 li.leftBox {
  padding: 70px 0 40px;
  background: #000;
}

.boxWrap .boxWrap2 li.leftBox .iconWrap {
  text-align: center;
}

.boxWrap .boxWrap2 li.leftBox .iconWrap img {
  width: 68px;
  height: 68px;
}

.boxWrap .boxWrap2 li.leftBox .title {
  color: #fff;
  font-size: 24px;
  font-weight: 500;
}

.boxWrap .boxWrap2 li.leftBox .desc {
  color: #5a5d9f;
  font-size: 16px;
  font-weight: 500;
}

.boxWrap .boxWrap2 li.leftBox .numWrap {
  padding: 20px 0 0;
  color: #3fe6ff;
  font-size: 40px;
  font-weight: 700;
}

.boxWrap .boxWrap2 li.rightBox {
  padding: 50px 0 40px;
  background: #fff;
}

.boxWrap .boxWrap2 li.rightBox .stepBox {
  display: flex;
  justify-content: space-around;
}

.boxWrap .boxWrap2 li.rightBox .stepBox>div {
  position: relative;
  width: 200px;
  height: 60px;
  line-height: 60px;
  border-radius: 10px;
  color: #fff;
}

.boxWrap .boxWrap2 li.rightBox .stepBox>div .imgWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.boxWrap .boxWrap2 li.rightBox .stepBox .ethereumStep {
  position: relative;
  background: #2a304c;
}

.boxWrap .boxWrap2 li.rightBox .stepBox .arenazStep {
  position: relative;
  background: #3700eb;
}

.boxWrap .boxWrap2 li.rightBox .stepBox>div:nth-child(1)::before {
  opacity: 0.2;
  display: inline-block;
  position: absolute;
  top: 50%;
  right: -22px;
  transform: rotate(45deg) translateY(-50%);
  width: 6px;
  height: 6px;
  border-top: 2px solid #00011a;
  border-right: 2px solid #00011a;
  border-radius: 1px;
  content: "";
}

.boxWrap .boxWrap2 li.rightBox .stepBox>div:nth-child(1)::after {
  opacity: 0.4;
  display: inline-block;
  position: absolute;
  top: 50%;
  right: -38px;
  transform: rotate(45deg) translateY(-50%);
  width: 6px;
  height: 6px;
  border-top: 2px solid #00011a;
  border-right: 2px solid #00011a;
  border-radius: 1px;
  content: "";
}

.boxWrap .boxWrap2 li.rightBox .stepBox .polygonStep {
  position: relative;
  background: #8247e5;
}

.boxWrap .boxWrap2 li.rightBox .stepBox>div:nth-child(2)::before {
  opacity: 0.8;
  display: inline-block;
  position: absolute;
  top: 50%;
  left: -30px;
  transform: rotate(45deg) translateY(-50%);
  width: 6px;
  height: 6px;
  border-top: 2px solid #00011a;
  border-right: 2px solid #00011a;
  border-radius: 1px;
  content: "";
}

.boxWrap .boxWrap2 li.rightBox .stepBox .ethereumStep .imgWrap {
  background: #edf0f6;
}

.boxWrap .boxWrap2 li.rightBox .stepBox .polygonStep .imgWrap {
  background: #441690;
}

.boxWrap .boxWrap2 li.rightBox .stepBox .arenazStep .imgWrap {
  background: none;
}

.boxWrap .boxWrap2 li.rightBox .stepBox .arenazStep .imgWrap img {
  position: relative;
  top: 1px;
  width: 28px;
}

.boxWrap .boxWrap2 li.rightBox .stepBox>div p {
  line-height: 1;
  padding-top: 22px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}

.boxWrap .boxWrap2 li.rightBox .forms {
  margin: 30px 0 0;
}

.boxWrap .boxWrap2 li.rightBox .forms .formWrap {
  position: relative;
}

.boxWrap .boxWrap2 li.rightBox .forms input {
  display: block;
  width: 470px;
  height: 70px;
  margin: 0 auto;
  padding: 0 100px 0 20px;
  border: 1px solid #d4ddeb;
  border-radius: 10px;
  color: #202431;
  font-size: 20px;
  font-weight: 700;
  text-align: right;
  box-sizing: border-box;
  letter-spacing: -0.5px;
}

.boxWrap .boxWrap2 li.rightBox .forms .formWrap label {
  position: absolute;
  top: 50%;
  right: 60px;
  transform: translateY(-50%);
  color: #a5aaba;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.2px;
}

.boxWrap .boxWrap2 li.rightBox .forms .btnPoint {
  width: 470px;
  height: 90px;
  margin: 10px 0 0;
  border: 0;
  border-radius: 10px;
  background: #361ad8;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 550ms ease-in-out;
}

.boxWrap .boxWrap2 li.rightBox .forms .btnPoint:hover {
  border-radius: 4px;
  background: linear-gradient(to top, #361ad8, #2b4ae7);
}

.history .title {
  display: flex;
  padding: 25px 40px;
  border-radius: 20px 20px 0 0;
  background: #141931;
  box-sizing: border-box;
}

.history .title img {
  width: 40px;
  height: 40px;
}

.history .title h4 {
  margin: 0 0 0 20px;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.2px;
}

.history .listItem {
  padding: 30px 40px;
  border-radius: 0 0 20px 20px;
  background: #fff;
}

.history .listItem table {
  width: 100%;
  border-spacing: 0;
}

.history .listItem table thead {
  height: 60px;
  background: #edf0f6;
}

.history .listItem table thead tr:first-child th:first-child {
  border-radius: 4px 0 0 0;
}

.history .listItem table thead tr:first-child th:last-child {
  border-radius: 0 4px 0 0;
}

.history .listItem table tr th {
  color: #04050d;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.16px;
}

.history .listItem table td {
  padding: 20px 0;
  border-bottom: 1px solid #e1e4eb;
  text-align: center;
}

.history .listItem table td:nth-child(1) {
  color: #202431;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.16px;
}

.history .listItem table td:nth-child(2) {
  color: #41a3ff;
  font-size: 14px;
  font-weight: 400;
}

.history .listItem table td:nth-child(3) {
  color: #41a3ff;
  font-size: 14px;
  font-weight: 400;
}

.history .listItem table td.processing p {
  color: #202431;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.13px;
}

.history .listItem table td.completed p {
  color: #dddddd;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.13px;
}

.history .listItem table td.claim p {
  width: 100px;
  height: 32px;
  line-height: 32px;
  margin: 0 auto;
  border-radius: 10px;
  background: #0d6eff;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  transition: transform 550ms ease-in-out;
  cursor: pointer;
}

.history .listItem table td.claim p:hover {
  border-radius: 4px;
  background: linear-gradient(to top, #0d6eff, #00a2ff);
}

/* popup */
.popup {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}

.popup.show {
  display: block;
}

.popup .popupWrap {
  position: absolute;
  top: 10%;
  left: 50%;
  width: 600px;
  border-radius: 10px;
  overflow: hidden;
  transform: translateX(-50%);
}

.popup .popupTitle {
  position: relative;
  padding: 12px 0;
  background-color: #361ad8;
}

.popup .popupTitle h5 {
  color: #fff;
  font-size: 24px;
  font-weight: 500;
  text-align: center;
}

.popup .popupTitle .popupCloseIco {
  display: block;
  position: absolute;
  top: 50%;
  right: 20px;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);
  cursor: pointer;
}

.popup .popupTitle .popupCloseIco::before,
.popup .popupTitle .popupCloseIco::after {
  content: "";
  position: absolute;
  top: 0;
  left: 10px;
  width: 2px;
  height: 20px;
  border-radius: 1px;
  background-color: #fff;
}

.popup .popupTitle .popupCloseIco::before {
  transform: rotate(45deg);
}

.popup .popupTitle .popupCloseIco::after {
  transform: rotate(-45deg);
}

.popup .popupText {
  padding: 40px 0;
  background: #fff;
}

.popup .popupText p {
  line-height: 1.8;
  color: #202431;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  letter-spacing: -0.16px;
}

.popup .popupText p>strong {
  color: #0d6eff;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.16px;
}

.popup .popupText .popupClose {
  display: block;
  width: 160px;
  height: 48px;
  margin: 30px auto 0;
  border: 0;
  border-radius: 10px;
  background-color: #13132d;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  transition: transform 550ms ease-in-out;
  cursor: pointer;
}

.popup .popupText .popupClose:hover {
  border-radius: 4px;
}

/* pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 44px 0 80px;
}

.pagination button {
  width: 60px;
  height: 40px;
  border: 1px solid #1f156b;
  border-radius: 4px;
  background-color: #07061e;
  background-repeat: no-repeat;
  background-position: 50%;
  cursor: pointer;
  transition: 0.1s;
}

.pagination button:hover {
  background-color: #080f3a;
}

.pagination #prevBtn {
  margin: 0 40px 0 0;
  background-image: url("/img/bridge/icon_prev_btn_off.svg");
}

.pagination #prevBtn:hover {
  background-image: url("/img/bridge/icon_prev_btn_on.png");
}

.pagination #nextBtn {
  margin: 0 0 0 40px;
  background-image: url("/img/bridge/icon_next_btn_off.svg");
}

.pagination #nextBtn:hover {
  background-image: url("/img/bridge/icon_next_btn_on.png");
}

.pagination input {
  width: 70px;
  height: 40px;
  border: 0;
  border-radius: 4px;
  background: #21243b;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  transition: 0.1s;
}

.pagination input:hover {
  border: 1px solid #0d6eff;
  box-sizing: border-box;
  background: #070920;
}

.pagination span {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
}

.pagination span:nth-of-type(1) {
  margin: 0 20px;
}

/* bridge submit btn */
.btnWrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnWrap button {
  width: 584px;
  height: 88px;
  border: 0;
  border-radius: 10px;
  background: #361ad8;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: transform 250ms cubic-bezier(0.1, 0.2, 0.3, 0.4);
}

.btnWrap button:hover {
  border-radius: 4px;
  background: linear-gradient(to top, #361ad8, #2b4ae7);
}

.breed-card-drago {
  width: 200px;
  height: 250px;
  border-radius: 8px;
  border: solid 0 #000;
  background-color: #fff;
}

.breed-card-drago-top {
  width: 200px;
  height: 200px;
  position: absolute;
  top: 0px;
  left: 0px;
}

.breed-card-drago-bottom {
  width: 200px;
  height: 53px;
  position: absolute;
  top: 200px;
  left: 0px;
}

.breed-card-name-text {
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202431;
}

.breed-card-tokenid-text {
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #202431;
}

.bg_drago {
  width: 632px;
  height: 500px;
  border-radius: 20px;
  border: solid 0 #000;
  background-color: #07071f;
}

.step1Title {
  padding-top: 16px;
  padding-left: 10px;
}

.step2Title {
  padding-top: 16px;
  padding-left: 10px;
}

.popup-head-text2 {
  font-family: Poppins;
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.popup-btn2 {
  width: 280px;
  height: 70px;
  border-radius: 2px;
  border: solid 0 #000;
  background-color: #0a1844;
  font-family: Poppins;
  padding-top: 22px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.BridgeBtnWrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  margin: 0 0 26px;
}

.BridgeBtnWrap button {
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 20px;
  border: 0;
  border-radius: 4px;
  background-image: url('/img/renewal/icon_refresh.png');
  background-repeat: no-repeat;
  background-position: 90% 50%;
}

.BridgeBtnWrap .ChangeWrap .EthWrap {
  min-width: 200px;
  background-color: #282a3a;
}

.BridgeBtnWrap .ChangeWrap .PolygonWrap {
  min-width: 200px;
  background-color: #8247e5;
}

.BridgeBtnWrap .ChangeWrap .ArenazWrap {
  min-width: 200px;
  background-color: #3700eb;
}

.BridgeBtnWrap button span {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 12px 0 0;
}

.BridgeBtnWrap .ChangeWrap .EthWrap span {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #fff;
}

.BridgeBtnWrap .ChangeWrap .PolygonWrap span {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #441690;
}

.BridgeBtnWrap .ChangeWrap .ArenazWrap span {
  background-color: transparent;
}

.BridgeBtnWrap .ChangeWrap .ArenazWrap span img {
  width: 28px;
}

.BridgeBtnWrap .ChangeWrap .EthWrap span img {
  width: 12px;
}

.BridgeBtnWrap .ChangeWrap .PolygonWrap span img {
  width: 16px;
}

.BridgeBtnWrap button p {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

.ChangeWrap {
  display: flex;
  gap: 20px;
}
.nodrago{
  background-color: #141931 !important;
}
</style>
